import React, { useState } from 'react';
import { rem } from 'design-system';
import { View } from 'react-native';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { IconEmma } from 'design-system/icons';
import { AvatarText } from 'design-system/avatar/AvatarText';
import FastImage from 'utils/packages/rnFastImage';
const SIZES = {
    small: {
        borderRadius: rem(6),
        imgSize: rem(24),
        iconSize: rem(16),
        padding: rem(0),
    },
    medium: {
        borderRadius: rem(6),
        imgSize: rem(32),
        iconSize: rem(20),
        padding: rem(1),
    },
    large: {
        borderRadius: rem(16),
        imgSize: rem(48),
        iconSize: rem(32),
        padding: rem(6),
    },
};
const FALLBACK_ICON = IconEmma;
const CreditReportLenderLogo = ({ iconUrl, size = 'medium', onDark, inSettingsItem, initialFallback = true, name, style, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const { borderRadius, imgSize, iconSize, padding } = SIZES[size];
    const FallbackIcon = FALLBACK_ICON;
    const [hasError, setHasError] = useState(false);
    const renderFallback = () => {
        if (initialFallback && name) {
            return (<AvatarText name={name} fontColor={colors.elements.brand} small={size === 'small'} medium={size === 'medium'} large={size === 'large'}/>);
        }
        return <FallbackIcon width={iconSize} height={iconSize}/>;
    };
    return (<View style={[
            {
                padding,
                borderRadius: borderRadius + padding,
                backgroundColor: onDark
                    ? colors.borders.iconStroke
                    : colors.borders.divider,
            },
            inSettingsItem && styles.settingsItemStyle,
            style,
        ]}>
      <View style={[
            styles.outer,
            { height: imgSize, width: imgSize, borderRadius },
        ]}>
        <View style={styles.inner}>
          {iconUrl && !hasError ? (<FastImage source={{ uri: iconUrl }} resizeMode="contain" style={{ width: '100%', height: '100%', borderRadius }} onError={() => setHasError(true)}/>) : (renderFallback())}
        </View>
      </View>
    </View>);
};
export default CreditReportLenderLogo;
const styleSet = createStyleSheets((colors) => ({
    inner: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    outer: {
        backgroundColor: colors.background.brandLight,
    },
    settingsItemStyle: {
        marginRight: rem(16),
    },
}));
